export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    loading: '加载中...',
    loadMore: '加载更多',
    noMore: '没有更多了',
    retry: '重试',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    refresh: '刷新',
    complete: '完成',
    skip: '跳过'
  },

  // 导航
  nav: {
    discover: '发现',
    message: '消息',
    store: '商店',
    mine: '我的',
  },

  // 首页
  home: {
    title: '角色扮演世界',
    subtitle: '开启你的专属故事',
    startGame: '开始游戏',
    continueGame: '继续游戏',
    newGame: '新游戏',
    gameLibrary: '游戏库',
    featured: '精选推荐',
    popular: '热门游戏',
    recent: '最近游戏',
    noData: '没有数据',
    noMoreData: '没有更多数据了'
  },

  // 用户
  user: {
    login: '登录',
    register: '注册',
    logout: '退出登录',
    profile: '个人资料',
    avatar: '头像',
    nickname: '昵称',
    email: '邮箱',
    phone: '手机号',
    password: '密码',
    confirmPassword: '确认密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    forgotPassword: '忘记密码',
    changePassword: '修改密码',
    bindPhone: '绑定手机',
    verifyCode: '验证码',
    sendCode: '发送验证码',
    level: '等级',
    experience: '经验值',
    achievement: '成就',
    history: '历史记录'
  },

  // 游戏
  game: {
    character: '角色',
    story: '剧情',
    chapter: '章节',
    scene: '场景',
    dialogue: '对话',
    choice: '选择',
    inventory: '背包',
    achievement: '成就',
    save: '保存游戏',
    load: '加载游戏',
    restart: '重新开始',
    pause: '暂停',
    resume: '继续',
    auto: '自动',
    speed: '速度',
    volume: '音量',
    settings: '游戏设置'
  },

  // 消息提示
  message: {
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    networkError: '网络连接失败',
    serverError: '服务器错误',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '退出登录成功',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteConfirm: '确认删除吗？',
    operationConfirm: '确认执行此操作吗？',
    noNewsYet: '暂无消息',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteMessage: '确认删除消息吗？',
    delete:'删除',
    deleting: '删除中...',
    noMoreData: '没有更多消息了',
    downloading: '下载中...',
    downloadSuccess: '下载成功',
    downloadFailed: '下载失败',
    translating: '翻译中...',
    translateSuccess: '翻译成功',
    translateFailed: '翻译失败'
  },
  // 成功
  success:{
    refreshSuccess: '刷新成功',
  },
  // 错误页面
  error: {
    notFound: '页面未找到',
    networkError: '网络错误',
    serverError: '服务器错误',
    permissionDenied: '权限不足',
    goHome: '返回首页',
    tryAgain: '重试'
  },

  // 404页面
  notFound: {
    title: '页面未找到',
    description: '您访问的页面不存在或已被移动。',
    goHome: '返回首页',
    goBack: '返回上页'
  },

  // 设置
  settings: {
    language: '语言',
    theme: '主题',
    notification: '通知',
    privacy: '隐私',
    security: '安全',
    about: '关于',
    version: '版本',
    checkUpdate: '检查更新',
    clearCache: '清理缓存',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策'
  }
}
